import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import * as actions from '../../store/actions/index';

class Auth extends React.Component {
	constructor(props) {
		super(props);
		
		this.state = {
			email : "",
            password : ""
		};
	}
    
    componentDidMount() {
        if (this.props.authRedirectPath !== '/') {
            this.props.onSetAuthRedirectPath();
        }
    }

	validateForm() {
		return this.state.email.length > 0 && this.state.password.length > 0;
	}
	
	inputChangeHandler = event => {
		this.setState({
			[event.target.id]: event.target.value
		});
	}
	
	submitHandler = event => {
		event.preventDefault();
		this.props.onAuth( this.state.email, this.state.password );
	}
	
    render() {
        let errorMessage = null;

        if (this.props.error) {
            errorMessage = (
                <p>{this.props.error.message}</p>
            );
        }

        let authRedirect = null;
        if (this.props.isAuthenticated) {
            authRedirect = <Redirect to={this.props.authRedirectPath}/>
        }

        return (
            <div className="block-center mt-xl wd-xl">
                {authRedirect}
                
                { /* START panel */ }
                <div className="panel panel-flat mt-xl">
                    <div className="panel-heading text-center">
                        <a href="/">    
                            <img src={require('../../img/logo-atis.png')} alt="Atis System" className="block-center img-rounded" />
                        </a>
                    </div>
                    <div className="panel-body">
                        <form className="mb-lg" onSubmit={this.submitHandler}>
                            <div className="form-group has-feedback">
                                <input id="email" type="text" placeholder="Login" 
                                        autoComplete="off" required="required" className="form-control" 
										value={this.state.email}
                                        onChange={this.inputChangeHandler}
                                        autoFocus={true}
								/>
                                <span className="form-control-feedback text-muted">
									<span className="fa fa-user"  ></span>
								</span>
                            </div>
                            <div className="form-group has-feedback">
                                <input id="password" type="password" 
                                    placeholder="Mot de passe" required="required" className="form-control" 
									value={this.state.password}
									onChange={this.inputChangeHandler}
								/>
                                <span className="form-control-feedback text-muted" >
                                    <span className="fa fa-lock"></span>
                                </span>
                            </div>
                            {/*}<div className="clearfix">
                                <div className="checkbox c-checkbox pull-left mt0">
                                    <label>
                                        <input type="checkbox" value="" id="remember" name="remember" />
                                        <em className="fa fa-check"></em>Se souvenir de moi</label>
                                </div>
                            </div>{*/}
                            <button type="submit" disabled={!this.validateForm()} className="btn btn-block btn-primary mt-lg">Connexion</button>
                            <div className="error" >{errorMessage}</div>
                        </form>
                    </div>
                </div>
                { /* END panel */ }
            </div>
            );
    }

}

const mapStateToProps = state => {
    return {
        loading: state.auth.loading,
        error: state.auth.error,
        isAuthenticated: state.auth.token !== null,
        authRedirectPath: state.auth.authRedirectPath
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onAuth: ( email, password ) => dispatch( actions.auth( email, password )),
        onSetAuthRedirectPath: () => dispatch(actions.setAuthRedirectPath('/'))
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( Auth );


// WEBPACK FOOTER //
// ./src/containers/Auth/Auth.js